import createIsAsyncValidating from './selectors/isAsyncValidating';
import plain from './structure/plain';

export default createIsAsyncValidating(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/isAsyncValidating.js
// module id = 660
// module chunks = 1